import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  CardActionArea,
  CardHeader,
  CardMedia,
  IconButton,
  Avatar, 
  Divider
} from '@material-ui/core';

import AccessTimeIcon from '@material-ui/icons/AccessTime';
import {postUserEditableDataAPIReq} from '../../../../utils/requests';


const useStyles = makeStyles(theme => ({
  media: {
    height: 140,
  },
}));

const CompanyDetails = props => {
  const { className, company, history, ...rest } = props;

  const classes = useStyles();

  let pictureURl = company.logo;

  const handleCompanyOfferClick = event => {
    event.preventDefault();
    history.push({
      pathname: '/offers',
      state: { filter: 'company_name', search: company.name }
    });
  };

  return (
    <Card  >
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={pictureURl}
          title={company.name}
        />
        <CardContent>
          <Typography
            component="h2"
            gutterBottom
            variant="h5"
          >
            {company.name}
          </Typography>
          <Typography
            color="textSecondary"
            component="p"
            variant="body2"
          >
            Located in {company.location}, {company.name} specializes in the {company.industry} industry
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          color="primary"
          href={'https://' + company.website}
          size="small"
        >
          Visit Website
        </Button>
        <Button
          color="primary"
          onClick={handleCompanyOfferClick}
          size="small"
        >
          {company.name} offers
        </Button>
      </CardActions>
    </Card>
  );
};

CompanyDetails.propTypes = {
  className: PropTypes.string,
  company: PropTypes.object.isRequired,
  history: PropTypes.object
};

export default CompanyDetails;
